import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import { Loader } from '../../../components/loader';
import { addHwFindUs } from '../../../actions/howFindUs';

const $ = window.$;
const intialState ={
    currentStep: 0,
    currentFormNotValid: false,
    newHwFindUS:'',
    loading: false,
};
class AddHwFindUs extends React.Component{
    constructor(props){
        super(props);
        this.state = intialState;
    }
    resetState = () => this.setState(Object.assign(intialState));
    handleChange = (fieldName) => (event) => {
        let obj = Object.assign({})
        obj[fieldName] = event.target.value
        this.setState(obj)
    }
    addHwType = (event) => {
        event.preventDefault();
        this.setState({loading:true});
        if(this.state.newHwFindUS.length > 0) {
            const data = {
                hw_find_us_type: this.state.newHwFindUS,
                PetShopId: this.props.petShop.currentPetshop.id,
            }
            this.props.addHwFindUs(data);
        }        
    }
    closeHwModal = () => {
        $('#add_hwf_type').modal('hide');
        this.resetState();
    }
    componentWillReceiveProps= (nextProps) => {
        if(this.props.newHwFindUS !== nextProps.newHwFindUS) {
            this.setState({newHwFindUS:'', loading:false})
            NotificationManager.success("New 'How you find us' type added succesfully.")
            $('#add_hwf_type').modal('hide');
        }
        if(this.props.newHwFindUSError!==this.props.newHwFindUSError){
            this.setState({newHwFindUS:'', loading:false})
            NotificationManager.error("Something went wrong.")
            $('#add_hwf_type').modal('hide');
        }
        
    }
    render() {
        return (
            <div className="modal fade show" id="add_hwf_type" tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">

                        <form className="m-form">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">New 'How you find us?' Type</h5>
                                <button type="button" className="close" onClick={this.closeHwModal} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">

                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="m-form__section m-form__section--first">

                                            <div className="form-group m-form__group row">
                                                <label className="col-xl-3 col-lg-3 col-form-label">How you find us:</label>
                                                <div className="col-xl-9 col-lg-9">
                                                    <input type="text" name="newHwFindUS" onChange={this.handleChange('newHwFindUS')} value={this.state.newHwFindUS} className="form-control m-input" placeholder="" />
                                                    <span className={this.state.inputNotValid ? "m-form__help_danger" : "m-form__help"}>Please add how you find us  type</span>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                {this.state.loading == false ?
                                    <div>
                                        <button type="button" className="btn btn-secondary m-btn--pill mx-2" onClick={this.closeHwModal}>Close</button>
                                        <button onClick={(event) => this.addHwType(event)} className="btn btn-primary m-btn--pill">Submit</button>
                                    </div>
                                    :
                                    <div className="center-row">
                                        <Loader size={50} />
                                    </div>
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state =>({
    petShop:state.petShopReducer,
    newHwFindUS:state.howFindUsReducer.newHwType,
    newHwFindUSError:state.howFindUsReducer.newHwFindUSError
});
const mapDispatchToProps = dispatch => ({
    addHwFindUs : (item) => {
        dispatch(addHwFindUs(item));
    }
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddHwFindUs));
